import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { faqList } from '@/mocks/faq';

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        '@id': 'http://lalaccu.cn/about',
        url: 'http://lalaccu.cn/about',
        name: '关于我们 - 51app',
        description: '51app 是国内领先的吃瓜爆料资讯平台，专注于收集和整理全网最热门的网红爆料、明星八卦等内容。',
        isPartOf: { '@id': 'http://lalaccu.cn/' },
      },
      {
        '@type': 'Organization',
        name: '51app',
        url: 'http://lalaccu.cn/',
        logo: 'http://lalaccu.cn/logo.png',
        description: '全网最热门的吃瓜爆料平台',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-5151',
          contactType: 'customer service',
          areaServed: 'CN',
          availableLanguage: 'Chinese',
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: '互联网小镇A座',
          addressLocality: '杭州',
          addressRegion: '浙江',
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'http://lalaccu.cn/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '关于我们',
            item: 'http://lalaccu.cn/about',
          },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqList.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 51app | 全网吃瓜爆料平台"
        description="了解51app品牌故事、平台优势和联系方式。51app是国内领先的吃瓜爆料资讯平台，500万用户信赖之选。免费下载安装51app，获取全网最热八卦爆料。"
        keywords="51app,关于我们,品牌介绍,吃瓜平台,爆料平台,联系方式,51app下载,免费app"
        canonical="/about"
        schema={schema}
      />
      <Navbar />
      <main className="pt-24 md:pt-28">
        <div className="px-4 md:px-8 max-w-4xl mx-auto">
          <div className="mb-6">
            <Breadcrumb items={[{ label: '关于我们' }]} />
          </div>

          {/* Hero */}
          <section className="mb-12 md:mb-16">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-500 leading-tight mb-4">
              关于 51app
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl">
              51app 是国内领先的吃瓜爆料资讯平台，专注于收集和整理全网最热门的网红爆料、明星八卦、聊天记录曝光、视频爆料等内容。我们致力于为用户提供最新、最真实、最劲爆的网络热点资讯。
            </p>
          </section>

          {/* Brand Story */}
          <section className="mb-12 md:mb-16">
            <h2 className="font-heading text-xl md:text-2xl text-primary-500 mb-5">
              品牌故事
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p>
                51app 诞生于2023年，创始团队是一群热爱互联网文化的年轻人。我们发现，在信息爆炸的时代，网友对真实、劲爆的网络爆料有着强烈的需求，但市面上缺乏一个专门整理和筛选这类内容的平台。
              </p>
              <p>
                于是，51app 应运而生。我们以"让每个人都能第一时间吃到最新鲜的瓜"为使命，组建了专业的内容采集团队，7x24小时监控全网热点，确保用户打开 app 就能看到最新的爆料内容。
              </p>
              <p>
                经过两年多的发展，51app 已经积累了超过500万注册用户，累计发布爆料文章10万余篇，总阅读量突破1亿次。我们始终坚持内容为王，严格审核每一条爆料，确保信息的真实性和可靠性。
              </p>
            </div>
          </section>

          {/* Advantages */}
          <section className="mb-12 md:mb-16">
            <h2 className="font-heading text-xl md:text-2xl text-primary-500 mb-5">
              平台优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                {
                  icon: 'ri-speed-line',
                  title: '实时更新',
                  desc: '7x24小时不间断监控全网热点，确保爆料内容第一时间呈现。',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '严格审核',
                  desc: '专业编辑团队对每条爆料进行核实，过滤虚假信息，保证内容真实可靠。',
                },
                {
                  icon: 'ri-thumb-up-line',
                  title: '完全免费',
                  desc: '下载使用完全免费，所有内容均可免费阅读观看，不设任何付费墙。',
                },
                {
                  icon: 'ri-brain-line',
                  title: '智能推荐',
                  desc: '基于AI算法分析用户阅读偏好，精准推荐你可能感兴趣的爆料内容。',
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="rounded-xl bg-background-100 p-5 md:p-6"
                >
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                    <i className={`${item.icon} w-5 h-5 flex items-center justify-center text-accent-600`} />
                  </div>
                  <h3 className="font-heading text-base md:text-lg text-foreground-800 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-12 md:mb-16">
            <h2 className="font-heading text-xl md:text-2xl text-primary-500 mb-5">
              联系我们
            </h2>
            <div className="rounded-xl bg-background-100 p-5 md:p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-primary-600" />
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">客服邮箱</p>
                    <p className="text-sm text-foreground-700">hello@lalaccu.cn</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-primary-600" />
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">客服热线</p>
                    <p className="text-sm text-foreground-700">400-888-5151</p>
                    <p className="text-xs text-foreground-400 mt-0.5">工作日 9:00-18:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-primary-600" />
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">公司地址</p>
                    <p className="text-sm text-foreground-700">杭州市滨江区互联网小镇A座</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className="ri-briefcase-line w-5 h-5 flex items-center justify-center text-primary-600" />
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">商务合作</p>
                    <p className="text-sm text-foreground-700">hello@lalaccu.cn</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-16 md:mb-20">
            <h2 className="font-heading text-xl md:text-2xl text-primary-500 mb-5">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqList.map((faq, index) => (
                <div
                  key={index}
                  className="rounded-xl bg-background-100 overflow-hidden"
                >
                  <button
                    type="button"
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    aria-expanded={openFaq === index}
                  >
                    <span className="font-medium text-foreground-800 text-sm md:text-base pr-4">
                      {faq.question}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center shrink-0 text-foreground-400 transition-transform ${
                        openFaq === index ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>

          {/* CTA */}
          <section className="mb-16 md:mb-20 text-center">
            <h2 className="font-heading text-2xl md:text-3xl text-primary-500 mb-3">
              立即加入 51app
            </h2>
            <p className="text-foreground-500 mb-6 max-w-lg mx-auto">
              下载安装51app，第一时间获取全网最热吃瓜爆料，与500万用户一起畅聊八卦。
            </p>
            <div className="flex items-center justify-center gap-3">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-download-line w-5 h-5 flex items-center justify-center" />
                免费下载
              </Link>
              <Link
                to="/category/wanghong-baoliao"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border-2 border-primary-500 text-primary-500 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                浏览爆料
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </Link>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}